// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2tMk7","detailsBorder":"styles_detailsBorder__2Llx2"};